import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  Box,
  Text,
  Button,
  Layer,
  FormField,
  RadioButtonGroup,
  Select
} from "grommet";
import "./CreateKitSidebar.css";
import close from "../../../../../../assets/close_small (1).svg";
import MedicalKitService from "../../../../../../services/medical-kit/medical-kit.service";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import usersService from "../Users/users.service";
import { FlightService } from "../../../../../../services/flights/flight.service";
import FormSubmit from '../../../../../../services/form/formSubmit';
import { APIs } from "../../../../../../util/api/APIs.tsx";
import SafeairManager from "../../../../../../util/api/SafeairManager";



const CreateKitSidebar = ({ onClose }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [apiResponseData, setApiResponseData] = useState([]);
  const [expiryDates, setExpiryDates] = useState([]);
  const [original, setOriginal] = useState([]);
  const [sorted, setSorted] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [items] = useState(
    [...Array(95).keys()].map((n) => ({ id: n, name: `Item ${n + 1}` }))
  );
  const [isOthersChecked, setIsOthersChecked] = useState(false);
  const [othersValue, setOthersValue] = useState("");
  const [isAnyCheckboxSelected, setIsAnyCheckboxSelected] = useState(false);
  const [openCalender, setOpenCalender] = useState(false);
  const [selectedKit, setSelectedKit] = useState("");
  const [filteredFlightList, setFilteredFlightList] = useState([]);
  const [originalFlightList, setOriginalFlightList] = useState([]);
  const [refurbishmentDueDate, setRefurbishmentDueDate] = useState("");
  const itemsPerPage = 10;
  const totalItems = items.length;
  // const totalItems = 100;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const { rootStore } = useStore();

  // const flightList = useMemo(() => rootStore.emsStore.getFlightList, [rootStore.emsStore.getFlightList]);

  // useEffect(() => {
  //   setFilteredFlightList(flightList);
  // }, [flightList]);


  useEffect(() => {
    // When apiResponseData changes, initialize expiryDates with empty expiryDate
    if (apiResponseData.length > 0) {
      const initialData = apiResponseData.map((item) => ({
        itemId: item.id, // Assuming `id` exists in the API response
        expiryDate: "", // Default empty string for expiryDate
      }));
      setExpiryDates(initialData);
    }
  }, [apiResponseData]); // Run when apiResponseData updates

  // Function to update expiry date for a specific itemId
  const handleDateChange = (itemId, date) => {
    setExpiryDates((prevDates) =>
      prevDates.map((item) =>
        item.itemId === itemId ? { ...item, expiryDate: date } : item
      )
    );

  };

  const filterFlight = (searchString) => {
    if (searchString) {
      let newFlightList = originalFlightList.filter(a => {
        return a.tailNumber.toLowerCase().includes(searchString.toLowerCase());
      });
      setFilteredFlightList(newFlightList)
    } else {
      setFilteredFlightList(originalFlightList)
    }
  }

  // useEffect(() => {
  //   let orgId;
  //   const getOrg = async () => {
  //     const organizationsResponse = await usersService.listOrganizations();
  //     const currentUserOrgName = rootStore.adminStore.getSelectedOrgName.toLowerCase();
  //     const currentUserOrgId = organizationsResponse.filter(org=>org.name.toLowerCase() === currentUserOrgName)[0].id;
  //     getFlightrelatedToOrg(currentUserOrgId)
  //   }
  //   getOrg()
  // }, [])

  useEffect(() => {
    getFlightrelatedToOrg()
  }, [])

  const getFlightrelatedToOrg = async () => {
    let Flights = await FlightService.listFlights();
    console.log("import", Flights)
    setFilteredFlightList(Flights);
    setOriginalFlightList(Flights)
  }


  const handleChangeFlightNumber = (event) => {
    rootStore.medicalKitStore.handleFlightNo(event.target.value);
  };

  const handleChangeExpiryDate = ({ value }) => {
    rootStore.medicalKitStore.handleExpiry(value);
  };
  const handleIconClick = () => {
    setOpenCalender(!openCalender)
  }


  const handleCheckBoxChange = (item) => {
    const newSelectedItems = {
      ...selectedItems,
      [item.id]: !selectedItems[item.id],
    };
    setSelectedItems(newSelectedItems);

    const anySelected = Object.values(newSelectedItems).some(
      (isSelected) => isSelected
    );
    setIsAnyCheckboxSelected(anySelected);

    if (item.id) {
      rootStore.medicalKitStore.setItems(item.id);
    } else {
      rootStore.medicalKitStore.setItems("", item.name);
    }
  };

  const handleOthersChange = (e) => {
    setOthersValue(e.target.value);
  };

  const handleOthersCheckboxChange = () => {
    setIsOthersChecked(!isOthersChecked);
  };

  const handleAddOthers = () => {
    if (isOthersChecked && othersValue.trim()) {
      const newItem = {
        id: "",
        name: othersValue,
        photoUrl: null,
        photoName: null,
      };
      setSorted([...sorted, newItem]);
      setSelectedItems({ ...selectedItems, [newItem.id]: false });
      setOthersValue("");
      setIsOthersChecked(false);
    }
  };

  useEffect(() => {
    getCreateKit();
  }, [rootStore.medicalKitStore, rootStore.MedicalKitStore]);

  useEffect(() => {
    return () => {
      rootStore.medicalKitStore.handleExpiry("");
      rootStore.medicalKitStore.handleFlightNo("");
    }
  }, []);

  const getCreateKit = async () => {
    try {
      const ItemData = await MedicalKitService.getCreateKit();

      rootStore.medicalKitStore.handlemedicallist(ItemData);
      setOriginal(ItemData);
      setSorted(ItemData);

      const initialSelectedItems = ItemData.reduce((acc, item) => {
        acc[item.id] = false;
        return acc;
      }, {});
      setSelectedItems(initialSelectedItems);
    } catch (error) {
      console.error("Error fetching medical kits:", error);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sorted.slice(indexOfFirstItem, indexOfLastItem);
  const showOthersSection = currentPage === totalPages;

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  // const onYearSelected = useCallback((year) => {
  //   rootStore.emsStore.setYearSelected(year);
  //   rootStore.emsStore.handleYearSelectionShow();
  // }, []);

  // const onMonthSelected = useCallback((month) => {
  //   rootStore.emsStore.setMonthSelected(month);
  //   rootStore.emsStore.handleYearSelectionShow();
  // }, []);

  const onYearSelected = useCallback((year) => {
    rootStore.emsStore.setYearSelected(year);
    rootStore.emsStore.handleYearSelectionShow();
    const newDate = new Date(year, rootStore.emsStore.getMonthSelected, 1);
    rootStore.emsStore.setSelectedDate(newDate);
  }, []);

  const onMonthSelected = useCallback((month) => {
    rootStore.emsStore.setMonthSelected(month);
    rootStore.emsStore.handleYearSelectionShow();
    const newDate = new Date(rootStore.emsStore.getSelectedYear, month, 1);
    rootStore.emsStore.setSelectedDate(newDate);
  }, []);




  const handleTextClick = () => {
    rootStore.emsStore.handleYearSelectionShow();
  }

  useLayoutEffect(() => {
    const textElement = document.querySelector('.calendar-customize h3');
    if (textElement) {
      textElement.addEventListener('click', handleTextClick);
    }
    return () => {
      if (textElement) {
        textElement.removeEventListener('click', handleTextClick);
      }
    };
  }, [handleTextClick]);

  const apiCall = async (name) => {
    setSelectedKit(name);  // Update the selected kit with the given name

    try {
      const apiConfig = {
        api: APIs.Form.showMedicalKitData,  // Use the API URL from your APIs object
        parameters: {
          kitType: name
        },
        body: null,
      };

      const res = await SafeairManager.invoke(apiConfig);
      setApiResponseData(res.data);
      return res;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };
  const handleCreatemedicalKit = async (name) => {
    const flightNumbers = rootStore.medicalKitStore.getFlightNo.split(",");

    const expiryDatesArray = Object.values(expiryDates).map((item) => ({
      itemId: item.itemId || "",
      expiryDate: item.expiryDate || "" // If no expiry date is picked, send an empty string
    }));

    try {
      const apiConfig = {
        api: APIs.Form.createMedicalKit,
        parameters: {},
        body: JSON.stringify({
          flightIds: flightNumbers,
          medicalKitType: name,
          refurbishmentDueDate: refurbishmentDueDate,
          dto: expiryDatesArray // Use array, NOT a stringified object
        }),
        headers: { "Content-Type": "application/json" },
      };

      const res = await SafeairManager.invoke(apiConfig);
      console.log("API Response:", res);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };


  const handleSave = async () => {
    if (!rootStore.medicalKitStore.getFlightNo) {
      rootStore.notificationToastStore.showNotification("Please select flight number.", true, 3000);
      return;
    } else if (!selectedKit) {
      rootStore.notificationToastStore.showNotification("Please select medical kit.", true, 3000);
      return;
    } else if (!refurbishmentDueDate) {
      rootStore.notificationToastStore.showNotification("Please select refurbishment due date.", true, 3000);
      return;
    };
    const flightNumbers = rootStore.medicalKitStore.getFlightNo.split(",");
    const postKitValue = selectedKit === "Epi Pen Medical Kit Standard" ? "epiPen" : selectedKit;
    console.log(rootStore.medicalKitStore.getFlightNo);
    try {
      const apiConfig = {
        api: APIs.Form.createMedicalKit,
        parameters: {},
        body: JSON.stringify({
          flightIds: flightNumbers,
          medicalKitType: postKitValue,
          refurbishmentDueDate: refurbishmentDueDate,
          dto: expiryDates
        }),
      };

      const res = await SafeairManager.createMedical(apiConfig);
      // console.log("API Response:", res);
      if (res) {
        rootStore.notificationToastStore.showNotification("MedicalKit added successfully", false, 3000);
        rootStore.medicalKitStore.handleupdate();
        onClose();
      }

    } catch (error) {
      let errorMessage = "Failed to create medical kit";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.errorMessage;
      }
      rootStore.notificationToastStore.showNotification(errorMessage, true, 3000);

      console.error("Error:", error);
      throw error;
    }

  };



  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  // Filter the flight list based on the search query
  const filteredList = filteredFlightList.filter((flight) => {
    const flightNumber = flight.tailNumber.toLowerCase(); // Convert the flight number to lowercase
    const query = searchQuery.trim().toLowerCase(); // Convert the search query to lowercase
    
    console.log('searchQuery:', searchQuery); // Log the current search query
    console.log('Flight number:', flightNumber); // Log the current flight number (tailNumber)
  
    // Perform the search comparison
    return flightNumber.includes(query); // Check if the flight number includes the search query
  });
  
  
  // Log the filtered list after the filtering process
  console.log('Filtered List:', filteredList);
  // Handle checkbox change
  const handleCheckboxChange = (option) => {
    setSelectedOptions((prevSelected) => {
      const isSelected = prevSelected.some((selected) => selected.value === option.value);
      let updatedSelection;

      if (isSelected) {
        // Remove the option if already selected
        updatedSelection = prevSelected.filter((selected) => selected.value !== option.value);
      } else {
        // Add the option if not selected
        updatedSelection = [...prevSelected, option];
      }

      // Update the root store with the latest selection
      const commaSeparatedString = updatedSelection.map((opt) => opt.value).join(",");
      rootStore.medicalKitStore.handleFlightNo(commaSeparatedString);
      console.log(rootStore.medicalKitStore.getFlightNo);

      return updatedSelection;
    });
  };

  // Close dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  console.log('Filtered List:', filteredList);
console.log('Is Dropdown Open:', isDropdownOpen);

  return (
    <Layer
      full="vertical"
      position="right"
      onClickOutside={onClose}
      onEsc={onClose}
      style={{ borderRadius: "12px 0 0 12px", zIndex: 1000, width: "700px" }}
    >
      <Box
        className="create-kit-sidebar"
        background="light-1"
        elevation="medium"
        fill="vertical"
      >
        <div className="create-kit-header-container">
          <div className="header" style={{ padding: 0 }}>
            <Box>
              <Text className="title">Create New Kit</Text>
              <p className="description">**Please fill out the details for the new kit.**</p>
            </Box>
            <Button
              className="close-btn"
              onClick={onClose}
            >
              <img src={close} alt="close" />
              Close
            </Button>
          </div>
        </div>
        <Box style={{ padding: '16px 20px' }}>
          <form onSubmit={(e) => e.preventDefault()}>
            <Box direction="column" gap="medium" style={{ width: "80%" }}>
            <FormField name="flightNumber" className="label" style={{ width: "80%" }}>
              <label className="labels">Flight Number</label>

              {/* Custom input field to display the comma-separated string */}
              <div ref={dropdownRef} style={{ position: "relative" }}>
                <input
                  type="text"
                  value={selectedOptions.map((option) => option.label).join(", ")}
                  onClick={toggleDropdown} // Toggle dropdown when clicking on the main input field
                  readOnly // Main input is read-only to prevent manual editing
                  placeholder="Please Select Flight"
                  style={{ width: "100%", height: "50px" }}
                />

                {/* Display the search input box above the dropdown */}
                {isDropdownOpen && (
                  <div
                    style={{
                      width: "100%",
                      position: "absolute",
                      top: "50px", // Positioning the search input above the dropdown list
                      zIndex: 11,
                    }}
                  >
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                      placeholder="Search Flights"
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "8px 8px 0 0",
                        border: "1px solid #ccc",
                        marginBottom: "5px", // Reduce the space below the search input
                      }}
                    />
                  </div>
                )}

                {/* Custom dropdown with checkboxes */}
                {isDropdownOpen && (
                  <div
                    className="dropdown"
                    style={{
                      border: "1px solid #ccc",
                      maxHeight: "150px",
                      overflowY: "auto",
                      position: "absolute",
                      top: "92px", // Adjust this top value to ensure dropdown starts below search input
                      width: "100%",
                      background: "#fff",
                      zIndex: 10,
                    }}
                    onMouseDown={(e) => e.preventDefault()} // Prevent input blur when clicking inside dropdown
                  >
                    {/* List of filtered flight options */}
                    {filteredList.length > 0 ? (
                      filteredList.map((org) => (
                        <div key={org.id} style={{ padding: "8px", display: "flex", alignItems: "center" }}>
                          <input
                            id={`checkbox-${org.id}`}
                            type="checkbox"
                            checked={selectedOptions.some((selected) => selected.value === org.id)}
                            onChange={() => handleCheckboxChange({ label: org.tailNumber, value: org.id })}
                            style={{ marginRight: "8px" }}
                          />
                          <label htmlFor={`checkbox-${org.id}`} style={{ cursor: "pointer" }}>
                            {org.tailNumber}
                          </label>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "8px" }}>No results found</div> // Show a message if no options match the search
                    )}
                  </div>
                )}
              </div>
            </FormField>
            <FormField name="refurbishmentDueDate" className="label" style={{ width: "80%" }}>
              <label className="labels">Refurbishment Due Date</label>
              <input
                type="date"
                value={refurbishmentDueDate}
                onChange={(e) => {
                  setRefurbishmentDueDate(e.target.value);
                  rootStore.medicalKitStore.handleRefurbishmentDueDate(e.target.value); // Update store
                }}
                style={{ width: "100%", height: "50px", padding: "5px", borderRadius: "4px", border: "1px solid #ddd" }}
              />
            </FormField>
            </Box>
          </form>
          <div className="data-table-container" style={{ marginTop: "65px" }}>
            <Text className="select-kit">Select Kit</Text>
            <div className="grid-container" >
              <RadioButtonGroup
                name="Medical Kit"
                options={[
                  { label: 'Aircraft medical kit standard', value: 'Standard' },
                  { label: 'Aircraft medical kit part 135', value: 'Small' },
                  { label: 'Canada AOHS', value: 'AOHS' },
                  { label: 'Epi Pen Medical Kit Standard', value: 'Epi Pen Medical Kit Standard' },
                ]}
                value={selectedKit}
                onChange={(event) => apiCall(event.target.value)}
                style={{
                  display: "flex",
                  width: "90%",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  marginBottom: "20px",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "24px",
                }}
              />
            </div>
            {
              apiResponseData.length > 0 && (
                <div className="data-table-container" style={{ marginTop: "20px", marginLeft: "20px" }}>
                  <Text className="select-kit">Kit Details</Text>
                  <table className="grid-container" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead style={{ width: '100%' }}>
                      <tr style={{ width: '100%' }}>
                        <th style={{ textAlign: "", padding: "10px", borderBottom: "1px solid #ddd", width: '400px' }}>Name</th>
                        <th style={{ textAlign: "", padding: "10px", borderBottom: "1px solid #ddd", width: '300px' }}>Expiry Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {apiResponseData.map((item, index) => (
                        <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                          <td style={{ padding: "10px", width: '400px' }}>{item.name}</td>
                          <td style={{ padding: "10px", width: '250px', display: "flex", justifyContent: "center" }}>
                            <input
                              type="date"
                              onChange={(e) => handleDateChange(item.id, e.target.value)}
                              style={{ padding: "5px", borderRadius: "4px", border: "1px solid #ddd" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            }

          </div>
          <div className="btn-outer" style={{ marginTop: "40px" }}>
            <Button
              className="reset"
              type="reset"
              label="Reset"
              onClick={() => {
                rootStore.medicalKitStore.handleFlightNo("");
                setSelectedKit("");
                setApiResponseData("");
                setExpiryDates({});
                setSelectedOptions([]);
                setRefurbishmentDueDate("");
              }}
              style={{
                display: "flex",
                width: "120px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                background: "#357EFF",
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "24px",
              }}
            />
            <Button
              className="save"
              type="submit"
              // label={isAnyCheckboxSelected ? "Save" : "Create"}
              label="Create"
              onClick={handleSave}
              style={{
                display: "flex",
                width: "120px",
                marginLeft: "10px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                background: "#357EFF",
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "24px",
              }}
            />
          </div>
        </Box>
      </Box>
    </Layer>
  );
};

export default observer(CreateKitSidebar);
